export class PhotoModel {
  orderId: number;
  key: string;

  constructor(orderId?: number, key?: string) {
    this.orderId = orderId;
    this.key = key;
  }
}
